import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

export const $FilterWrapper = styled.div`
  border-bottom: 1px solid ${({ theme }) => theme.colors.lightGrey};
  padding: ${spacing('sm')} ${spacing('lg')};
  &:last-child {
    border-bottom: none;
  }
`;

export const $FilterContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  padding: 0;
  background-color: ${({ theme }) => theme.systemColors.defaultBackground};
  min-height: ${spacing(10)};
  border-radius: ${({ theme }) => theme.tw.radius.sm};

  transition: border-color 150ms ease;
  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
  }
`;

export const $FilterSelectedValues = styled.div`
  max-width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:first-letter {
    text-transform: uppercase;
  }
`;

export const $FilterSelectedDatePicker = styled.div`
  width: 100%;

  && .react-datepicker-popper {
    z-index: 20 !important;
  }
`;

export const $FilterContentRightBlock = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
`;

export const $FilterMenuContainer = styled.div<{
  $hasPaddingX?: boolean;
}>`
  position: relative;
  min-height: ${spacing(10)};
  height: auto;
  background-color: ${({ theme }) => theme.systemColors.defaultBackground};

  padding: 0 ${({ $hasPaddingX }) => ($hasPaddingX ? spacing('lg') : 0)};

  display: block;
`;

export const $FilterSelectedSlider = styled.div`
  width: 100%;
`;
